// Keep direct stage links scoped to tickets already allowed by the venue API.
export function scopeVenueLayoutToStage(layout, stageId, codeOnly = false) {
  const hasStage = stageId !== null && stageId !== undefined && stageId !== ''
  if (!hasStage && !codeOnly) return layout
  const requestedId = Number(stageId)
  const source = layout || {}
  const sections = (Array.isArray(source.sections) ? source.sections : []).flatMap((section) => {
    const available = Array.isArray(section.tickets) && section.tickets.length
      ? section.tickets
      : (section.ticket ? [section.ticket] : [])
    const tickets = hasStage ? available.filter((ticket) => Number(ticket.id) === requestedId) : available
    if (!tickets.length) return []
    const ticket = tickets[0]
    return [{
      ...section,
      tickets,
      ticket,
      is_configured: true,
      available_quantity: ticket.remaining_tickets ?? null,
    }]
  })
  const bySection = new Map(sections.map((section) => [section.id, section]))
  const seats = (Array.isArray(source.seats) ? source.seats : [])
    .filter((seat) => bySection.has(seat.section_id))
    .map((seat) => {
      const ticket = bySection.get(seat.section_id).ticket
      return {
        ...seat,
        ticket_id: ticket.id,
        ticket_ids: bySection.get(seat.section_id).tickets.map((item) => item.id),
        ticket_name: ticket.name,
        price: ticket.price,
      }
    })
  return { ...source, sections, seats }
}
